'use client';

import { Suspense, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { RegistrationStatus, UserType } from '@/types/pam-api';
import { IS_SET_USER_ATTRIBUTE_STORAGE_KEY } from '@/features/analytics/constants';
import { EventDataMap, sendPageViewEvent, sendUserAttributesEvent, sendUserIdEvent } from '@/features/analytics/datalayer';
import useUser from '@/utils/use-user';
import { ValidatedScripts } from '../response-data-validator';
interface Props {
  gtmData: ValidatedScripts['gtm'];
}
export const GTMBodyScript = ({
  gtmData
}: Props) => {
  const pathname = usePathname();
  const {
    isLoggedIn,
    user
  } = useUser();
  const isGTMEnabled = gtmData?.enabled;
  useEffect(() => {
    if (!isGTMEnabled) return;
    if (isLoggedIn && sessionStorage.getItem(IS_SET_USER_ATTRIBUTE_STORAGE_KEY) !== 'set') {
      let userType: EventDataMap['user_attributes']['data']['user_type'] = null;
      if (user?.userType) {
        userType = user.userType.toLowerCase() as Lowercase<UserType>;
      } else if (user?.registrationStatus === RegistrationStatus.NewUser) {
        userType = 'new';
      }
      sendUserAttributesEvent({
        data: {
          logged_in: isLoggedIn ? 'true' : 'false',
          user_id: user?.id || null,
          aov: user?.aov || null,
          user_type: userType,
          total_order: user?.totalOrder ?? 0,
          last_purchase: user?.lastPurchaseDay ?? null,
          city: user?.lastAddressCityName ?? null,
          province: user?.lastAddressProvinceName ?? null
        }
      });
      sendUserIdEvent({
        user_id: user?.id || null
      });
      sessionStorage.setItem(IS_SET_USER_ATTRIBUTE_STORAGE_KEY, 'set');
    }
  }, [isGTMEnabled, pathname, isLoggedIn, user?.id, user?.aov, user?.userType, user?.totalOrder, user?.lastPurchaseDay, user?.lastAddressCityName, user?.lastAddressProvinceName, user?.registrationStatus]);
  useEffect(() => {
    if (!pathname || !isGTMEnabled) return;
    sendPageViewEvent({
      page: pathname
    });
  }, [isGTMEnabled, pathname]);
  if (!isGTMEnabled) return null;
  return <Suspense data-sentry-element="Suspense" data-sentry-component="GTMBodyScript" data-sentry-source-file="gtm-body.tsx">
            <noscript>
                <iframe src={`https://www.googletagmanager.com/ns.html?id=${gtmData.config.containerId}`} height='0' width='0' className='invisible hidden' title='GTAG'></iframe>
            </noscript>
        </Suspense>;
};